import React, { useState } from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import { Button } from "@mui/material";
import { useUserInfo } from "../../../context/user";
import { useUsersContext } from "../../../context/usersContext";
import { useRenameChat } from "../../../queries/chatActions";

const RenameChatModal = ({ isOpen, onClose, chatTitle, id }) => {
  const [input, setInput] = useState(chatTitle || "");
  const [error, setError] = useState();
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const {
    fetchChats
  } = useUsersContext();
  const { mutateAsync: renameChat, isPending: processing } = useRenameChat();

  const handleCategorySubmit = async () => {
    setError(false);

    if (input === "" || input === undefined) {
      setError(true);
      return false;
    }

    const response = await renameChat({
      conversation_id: id,
      name: input,
      userId: userInfo?._id,
      locationId: userActiveLocation?.id,
    });
    fetchChats()
    if (response) {
      onClose();
      setInput("");
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <p className="text-[14px] font-[600] truncate">{`Rename '${chatTitle || "hi"}'`}</p>
      }
      showAlert={false}
    >
      <input
        type="text"
        onChange={(e) => setInput(e.target.value)}
        value={input}
        className="!outline-0 border border-border"
      />
      {error && <small style={{ color: "red" }}>name required!</small>}
      <Button
        className="!text-[14px] !font-[600] !mt-4 !bg-primary !text-primary-foreground w-full flex items-center gap-3 justify-center"
        disabled={processing}
        onClick={handleCategorySubmit}
      >
        {processing && <div className="spinner"></div>} <span>Update</span>
      </Button>
    </CommonModal>
  );
};

export default RenameChatModal;
